import { Bug, HelpCircle, Lightbulb, MessageCircle } from "lucide-react";

/**
 * What a support message can be about. The welcome screen
 * (`components/support/SupportWelcome.jsx`) lists these; the compose screen
 * (`components/SupportDialog.jsx`) reads the chosen one again for its header
 * chip, the prompt Sabine asks, whether to ask about urgency and whether to
 * offer a walkthrough video. Both screens are here so the two can never drift.
 */

// The tint each category's icon carries, on both screens.
export const CATEGORY_TONES = {
  blue: {
    bg: "bg-action-50",
    icon: "text-action-600",
    hoverBg: "group-hover:bg-action-100",
  },
  red: {
    bg: "bg-red-50",
    icon: "text-red-600",
    hoverBg: "group-hover:bg-red-100",
  },
  amber: {
    bg: "bg-warning-50",
    icon: "text-warning-600",
    hoverBg: "group-hover:bg-warning-100",
  },
  gray: {
    bg: "bg-gray-100",
    icon: "text-gray-600",
    hoverBg: "group-hover:bg-gray-200",
  },
};

// `value` is the ticket's category. `suggestWalkthrough` offers a walkthrough
// video while the message is being typed, for the two categories a how-to
// answers: a question, and a problem that is usually a setup step.
export const SUPPORT_CATEGORIES = [
  {
    id: "help",
    value: "confusion",
    label: "Ask a question",
    description: "How do I...?",
    icon: HelpCircle,
    color: "blue",
    prompt: "What would you like to know?",
    suggestWalkthrough: true,
  },
  {
    id: "bug",
    value: "ui-bug",
    label: "Report a problem",
    description: "Something's not working right",
    icon: Bug,
    color: "red",
    prompt: "What went wrong?",
    showUrgency: true,
    suggestWalkthrough: true,
  },
  {
    id: "feature",
    value: "feature",
    label: "Share an idea",
    description: "Suggest an improvement",
    icon: Lightbulb,
    color: "amber",
    prompt: "What would make this better?",
  },
  {
    id: "other",
    value: "other",
    label: "Say hello",
    description: "Feedback, praise, or anything else",
    icon: MessageCircle,
    color: "gray",
    prompt: "What's on your mind?",
  },
];
